import React, { useMemo } from 'react';
import classNames from 'classnames';
import { stylePackOptions } from '../../utils/content-templates';
import TellyComingSoon from '../../images/telly-coming-soon.svg';

export interface StylePackOptionProps {
	type: string;
}

function OptionsComingSoon({ optionType }: { optionType: string }) {
	return (
		<div className={classNames(`coming-soon-${optionType}`)}>
			<div className="coming-soon-background" />
			<img src={TellyComingSoon} />
			<div>
				<h5 className="bl-font-header margin-none">More {optionType} coming soon!</h5>
				<span className="bl-font-s2" style={{ opacity: '50%' }}>Stay tuned</span>
			</div>
		</div>
	);
}

export default function StylePackOptions({ type }: StylePackOptionProps) {
	const stylePackColorwayOptions = useMemo(() => stylePackOptions.filter(
		(option) => option.type === 'colorway' && option.style_pack_types.includes(type),
	), [type]);

	const stylePackFontOptions = useMemo(() => stylePackOptions.filter(
		(option) => option.type === 'font' && option.style_pack_types.includes(type),
	), [type]);

	return (
		<>
			{stylePackColorwayOptions.length > 0 && (
				<div className="style-pack-info-options flex-column" style={{ padding: '10px 16px 14px 16px' }}>
					<h6 className="bl-font-header margin-none">{stylePackColorwayOptions[0].name}</h6>
					<div className="color-swatch">{
						stylePackColorwayOptions[0].data.colors && (
							stylePackColorwayOptions[0].data.colors.map((color: string, index: number) => (
								<div
									key={`color-swatch-${index}`}
									style={{ backgroundColor: color, width: '100%' }}
								/>
							))
						)
					}</div>
					<OptionsComingSoon optionType="colorways" />
				</div>
			)}
			{stylePackFontOptions.length > 0 && (
				<div className="style-pack-info-options" style={{ padding: '22px 16px' }}>
					<img src={stylePackFontOptions[0].data.preview} className="font-preview"/>
					<OptionsComingSoon optionType="fonts" />
				</div>
			)}
		</>
	);
}
